

















































































import { Component } from 'vue-property-decorator';
import { HeaderList, List, Row } from '@/components/Table/TableModel';
import {
  CustomSelectModel,
  CustomSelectGroup,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import RowsTable from '@/components/Table/RowsTable.vue';
import AdminService from '@/api/AdminService';
import BasePagination from '@/components/BasePagination/BasePagination.vue';
import ContextMenu from '@/components/ContextMenu/ContextMenu.vue';
import ContextMenuOption from '@/components/ContextMenu/ContextMenuOption';
import TextInput from '@/components/TextInput/TextInput.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import eventBus from '@/utils/eventBus';
import { getBusinessLocationInfo } from '@/utils/businessLocationHelper';
import ModalOptions from '@/components/Modal/ModalOptions';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';

import Table from '@/components/molecules/Table/Table.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import UserIcon from '@/components/molecules/UserIcon/UserIcon.vue';
import DateUtils from '@/utils/DateUtils';
import { Typography } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';

@Component({
  components: {
    Table,
    RowsTable,
    ContextMenu,
    TextInput,
    CustomSelect,
    ContentContainer,
    TableFilters,
    TableCell,
    TableHeader,
    TableRow,
    UserIcon,
    Typography,
    FilledButton
  }
})
export default class BusinessList extends BasePagination {
  limit = 20;
  service: AdminService = new AdminService();
  businessList: List = new List([], []);
  fidelNullLabel = 'Pending';
  searchableFields = 'searchableFields=business.name';
  sortField = 'business.name';
  sortOrder = 'ASC';
  filterValuesSeparator = ':';

  created() {
    eventBus.$on('reloadBusinessOwnershipList', () =>
      this.reloadList(true, true)
    );
  }

  initFilterModel() {
    const actionGroup = new CustomSelectGroup([
      new CustomSelectOption('accepted', `Accepted`),
      new CustomSelectOption('pending', `Pending`)
    ]);

    this.filterModel = new CustomSelectModel(
      [actionGroup],
      `Filter by invitation status`,
      false,
      true,
      true,
      false
    );
  }

  getOptionsByData(business: any) {
    const options: ContextMenuOption[] = [
      {
        label: 'Transfer Ownership',
        action: 'transferOwnership'
      }
    ];

    return options;
  }

  optionSelected(action: string, props: Array<any>, business: any): void {
    switch (action) {
      case 'transferOwnership':
        this.transferOwnership(business);
        break;
      default:
        break;
    }
  }

  initHeader() {
    const header = [
      new HeaderList(`Business`, 'none', '12px'),
      new HeaderList(`Business name`, 'business.name'),
      new HeaderList(`Business Location`, 'business.city'),
      new HeaderList(`Invitation Status`, 'managerinvite.status'),
      new HeaderList(`Sent To`, 'managerinvite.mail'),
      new HeaderList(`Invitation Date`, 'managerinvite.updatedAt'),
      new HeaderList(``, 'none', '12px')
    ];
    this.businessList.header = header;
  }

  manageOwnership(business: any) {
    switch (business.inviteStatus) {
      case 'pending':
        this.revokeOwnership(business.inviteId);
        break;
      default:
        this.transferOwnership(business);
    }
  }

  revokeOwnership(inviteId: string) {
    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        'revokeOwnershipModal',
        false,
        true,
        true
      ),
      { inviteId }
    );
  }

  transferOwnership(business: any) {
    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        'transferOwnershipModal',
        false,
        true,
        true
      ),
      { business }
    );
  }

  reloadList(
    clearList?: boolean,
    refreshCurrent?: boolean,
    query?: string,
    notEmpty?: boolean
  ) {
    if (clearList) {
      this.resetPagination();
      if (!notEmpty) this.businessList.list = [];
      this.maxItems = false;
    }
    if (this.refreshing || this.maxItems) return;
    this.$showLoaderWithLocker();
    this.refreshing = true;

    this.service
      .getBusinessesList({
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pagination: this.pagination,
        filters: `${this.query}${
          !this.alreadyAddFilterOwnerInvite() ? '&withOwnerInvite=true' : ''
        }`
      })
      .then(response => {
        const { data } = response;
        const { items, links } = data;

        if (refreshCurrent) {
          // refresh page and reinitilize pagination
          this.resetPagination();
          this.pagination = decodeURIComponent(links.next);
          if (!links.next) this.maxItems = true;

          this.businessList.list = this.addRowsToList(items);
        } else {
          // refresh page and add items
          this.businessList.list = this.businessList.list.concat(
            this.addRowsToList(items)
          );
          if (!links.next) this.maxItems = true;
          this.pagination = decodeURIComponent(links.next);
        }
      })
      .catch(() => {})
      .finally(() => {
        if (this.hasLoadedMore && notEmpty) {
          const listElement = this.$refs.list as HTMLElement;
          listElement.scrollTo(0, 0);
          this.hasLoadedMore = false;
        }

        this.$hideLoader();
        this.isLoading = true;
        this.refreshing = false;
      });
  }

  addRowsToList(businessRows: any[]): any[] {
    return businessRows.map((business: any) => {
      const { ownerInvite } = business;
      return {
        id: business.id,
        picture: business.logo.publicPath.small,
        name: business.name,
        mail: business.manager.mail,
        managerName: business.manager.fullName,
        phone: business.phone,
        address: getBusinessLocationInfo(business),
        inviteStatus: ownerInvite.status,
        inviteEmail: ownerInvite.mail,
        inviteDate: DateUtils.formatISODate(ownerInvite.updatedAt),
        inviteId: ownerInvite.id
      };
    });
  }

  alreadyAddFilterOwnerInvite(): boolean {
    return this.pagination.indexOf('withOwnerInvite') > 0;
  }
}
